global.util = {
  obj2FormData (obj) {
    const formData = new FormData()
    console.log('分装Form参数对象：', obj)

    for (var key in obj) {
      // console.log(key + ':' + obj[key])
      formData.append(key, obj[key])
    }
    return formData
  }
}
